import { findLayer, refreshLayerMetadata } from '@/map/layers/registry';
import type { Tool } from './types';

type Input = { layer_id: string };

export const describeLayer: Tool<Input> = {
  name: 'describe_layer',
  description:
    'Full schema for a layer — service info, fields, types, coded-value domains, distinct samples, min/max, dead fields, optional sidecar notes. If the layer is "stub", a probe runs inline (~300 ms once per machine).',
  input_schema: {
    type: 'object',
    properties: { layer_id: { type: 'string' } },
    required: ['layer_id'],
    additionalProperties: false,
  },
  execute: async ({ layer_id }) => {
    let record = findLayer(layer_id);
    if (!record) throw new Error(`Unknown layer id: "${layer_id}"`);
    if (!record.probe) {
      try {
        await refreshLayerMetadata(layer_id);
      } catch {
        // we still want to return the stub state
      }
      record = findLayer(layer_id) ?? record;
    }
    return {
      id: record.id,
      url: record.url,
      status: record.status,
      flags: Array.from(record.flags),
      service: record.probe?.service ?? null,
      fields: record.probe?.fields ?? [],
      notes: record.notes ?? null,
      error: record.error ?? null,
    };
  },
};
